import { useLang } from "@/lib/i18n";
import AdStrip from "@/components/yts/ads/AdStrip";

/** A partner's site is theirs, not ours — never open it without a protocol. */
const href = (url) => (/^https?:\/\//i.test(url || "") ? url : `https://${url || ""}`);

/**
 * A paid-up space. It is built from the same strip as the experience banner
 * that fills an unsold one (see AdStrip), so every banner on the site keeps
 * exactly the same size whether a partner is there or not.
 */
export default function AdCreative({ campaign, compact = false }) {
  const { lang } = useLang();
  const sponsored = lang === "es" ? "Patrocinado" : "Sponsored";

  return (
    <AdStrip
      href={href(campaign.target_url)}
      thumb={campaign.image_url}
      thumbAlt={campaign.headline || campaign.advertiser || ""}
      ariaLabel={campaign.headline || campaign.advertiser || sponsored}
      overline={campaign.advertiser ? `${sponsored} · ${campaign.advertiser}` : sponsored}
      title={campaign.headline || campaign.advertiser}
      description={campaign.line}
      cta={lang === "es" ? "Visitar" : "Visit"}
      compact={compact}
    />
  );
}